import React from 'react';
import experienceData from '../config/experience';
import './styles/Timeline.scss';

const ExperienceTimeline = () => {
  return (
    <div>
      <h3 className="timeline-title">Experience</h3>
      <div className="timeline">
        {experienceData.map((item) => (
          <div className="timeline-item" key={item.id}>
            <div className="timeline-item-dot"></div>
            <div className="timeline-item-content">
              <h4 className="timeline-item-heading">{item.title}</h4>
              <p className="timeline-item-subheading">{item.company}, {item.location}</p>
              <span className="timeline-item-date">{item.startDate} &ndash; {item.endDate}</span>
              <div className="timeline-item-details">
                {item.description.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExperienceTimeline;